module.exports = __webpack_public_path__ + "img/icon_personal.a8cc153d.svg";